import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";

// 
import {
  clientname,
  currentTenant,
  logo,
  userid,
  currency
} from "../../Common/Credentials";
import moment from "moment";
import { spin } from "../../Common/NewLoader";
import { productionid } from "../../Common/Permissions";
import CustomToolbar from "../../CommonComponents/CustomToolbar";
import MUIDataTable from "mui-datatables";
import {
  FormControlLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import IOSSwitch from "../../CommonComponents/IOSSwitch";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ProductionServices from "../ProductionServices";
import Swal from 'sweetalert2';

import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";


// Import CSS
import '../../NewUI/NewUI.css';

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
});

class JobOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      active: [],
      completed: [],
      cancelled: [],
      loading: false,
      salestype: false,
      // New UI state
      hovered: null,
      hoveredRow: null,
      isActionHovered: null,
      searchTerm: "",
      showSearch: false,
      isMobile: window.innerWidth <= 768,
      activeTab: 'active',
      sortConfig: { key: 'createdAt', direction: 'desc' },
    };

    this.handleResize = this.handleResize.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.sortData = this.sortData.bind(this);
    this.refresh = this.refresh.bind(this);
    this.pdf = this.pdf.bind(this);
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key || !data) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'customjoid':
          aValue = a.customjoid || '';
          bValue = b.customjoid || '';
          break;
        case 'customestid':
          aValue = a.customestid || '';
          bValue = b.customestid || '';
          break;
        case 'assigntoname':
          aValue = a.assigntoname || '';
          bValue = b.assigntoname || '';
          break;
        case 'indstatus':
          aValue = a.indstatus || '';
          bValue = b.indstatus || '';
          break;
        case 'jostatus':
          aValue = a.jostatus || '';
          bValue = b.jostatus || '';
          break;
        case 'status':
          aValue = a.status || '';
          bValue = b.status || '';
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  handleActive = () => {
    this.setState({
      activeTab: 'active',
      searchTerm: "",
      sortConfig: { key: 'createdAt', direction: 'desc' }
    });
  };

  handleCompleted = () => {
    this.setState({
      activeTab: 'completed',
      searchTerm: "",
      sortConfig: { key: 'createdAt', direction: 'desc' }
    });
  };

  handleCancelled = () => {
    this.setState({
      activeTab: 'cancelled',
      searchTerm: "",
      sortConfig: { key: 'createdAt', direction: 'desc' }
    });
  };

  handleSearch(term) {
    this.setState({ searchTerm: term });
  }

  getFilteredData(data) {
    const { searchTerm } = this.state;
    if (!searchTerm.trim() || !data) return data;

    const cleanSearch = searchTerm.replace(/[^\w]/g, '').toLowerCase();

    return data.filter((item) => {
      const checkFields = [
        item.customjoid?.toString(),
        item.customestid,
        item.assigntoname,
        item.indstatus,
        item.jostatus,
        item.status,
      ];

      return checkFields.some((field) => {
        if (field === undefined || field === null) return false;

        const raw = String(field);
        const cleanField = raw.replace(/[^\w]/g, '').toLowerCase();

        return (
          cleanField.includes(cleanSearch) ||
          raw.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    });
  }

  pdf = () => {
    let pdfdata = this.state.data;
    pdfdata.map(
      (e) =>
      (pdfdata.find((i) => i.id === e.id).createdAt = moment(
        pdfdata.find((i) => i.id === e.id).createdAt
      ).format("DD-MM-YYYY hh:mm"))
    );
    pdfdata.map(
      (e) =>
      (pdfdata.find((i) => i.id === e.id).startdate = moment(
        pdfdata.find((i) => i.id === e.id).startdate
      ).format("DD-MM-YYYY"))
    );
    const columns = [
      { header: "JobOrder Id", dataKey: "id" },
      { header: "Estimation Id", dataKey: "estid" },
      { header: "Assign To", dataKey: "assignto" },
      { header: "Date", dataKey: "createdAt" },
    ];
    var doc = new jsPDF("p", "pt");
    doc.addImage(logo, "GIF", 40, 20, 60, 60);
    doc.setFontSize(16);
    doc.setFont("Times-Roman");
    doc.text(`${clientname}`, 180, 40);
    doc.setFontSize(14);
    doc.text(`Active Sale Orders`, 210, 80);
    doc.setFontSize(8);
    doc.text(`${moment().format("DD-MM-YYYY hh:mm")}`, 510, 80);
    doc.line(0, 90, 600, 90);
    autoTable(doc, {
      theme: "grid",
      startY: 100,
      columnStyles: { 7: { halign: "right" } },
      body: pdfdata,
      columns: columns,
    });
    doc.save("ActiveSaleordes.pdf");
    this.refresh();
  };

  refresh() {
    ProductionServices.getallJobOrders(currentTenant).then((response) => {
      this.setState({
        data: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        active: response.data.filter((e) => e.status === "Pending" || e.status === "Partial").sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        completed: response.data.filter((e) => e.status === "Completed").sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        cancelled: response.data.filter((e) => e.status === "Cancelled").sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        loading: false,
      });
    }).catch((error) => {
      console.error("Error fetching job orders:", error);
      if (error.response?.data?.error === "Unauthorized") {
        Swal.fire({
          title: "Your Session is Lost",
          text: "Please login back to resume",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#152f5f",
        }).then(() => this.props.navigate(`/`));
      }
      this.setState({ loading: false });
    });
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }

    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);

    this.setState({ loading: true });
    this.refresh();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  renderTabs() {
    const { activeTab, active, completed, cancelled } = this.state;

    const tabs = [
      { key: 'active', label: 'Active', count: active.length, action: this.handleActive },
      { key: 'completed', label: 'Completed', count: completed.length, action: this.handleCompleted },
      { key: 'cancelled', label: 'Cancelled', count: cancelled.length, action: this.handleCancelled },
    ];

    return (
      <div className="UI-quotation-tabs-container">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`UI-quotation-tab ${activeTab === tab.key ? 'UI-quotation-active-tab' : ''
              } ${this.state.hovered === `${tab.key}-tab`
                ? 'UI-quotation-tab-hovered'
                : ''
              }`}
            onClick={tab.action}
            onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {tab.label}
            {tab.count > 0 && (
              <span className="UI-match-count">{tab.count}</span>
            )}
          </div>
        ))}
      </div>
    );
  }

  renderActiveTable() {
    const { active, isMobile, searchTerm } = this.state;
    const filteredData = this.getFilteredData(active);
    const sortedData = this.getSortedData(filteredData);

    if (sortedData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {searchTerm ? 'No active job orders found matching your search' : 'No active job orders available'}
        </div>
      );
    }

    return (
      <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
        <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
          <thead className="UI-table-header">
            <tr>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customjoid' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('customjoid')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Job Order ID
                  <this.SortIndicator columnKey="customjoid" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customestid' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('customestid')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Estimation ID
                  <this.SortIndicator columnKey="customestid" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'assigntoname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('assigntoname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Assign To
                  <this.SortIndicator columnKey="assigntoname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'indstatus' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('indstatus')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Indenting Status
                  <this.SortIndicator columnKey="indstatus" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'jostatus' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('jostatus')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Inprocess Status
                  <this.SortIndicator columnKey="jostatus" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'status' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('status')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Status
                  <this.SortIndicator columnKey="status" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('createdAt')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Date
                  <this.SortIndicator columnKey="createdAt" />
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedData.map((item) => (
              <tr
                key={item.id}
                className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                onMouseLeave={() => {
                  this.setState({ hoveredRow: null, isActionHovered: null });
                }}
              >
                {/* Job Order ID */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}>
                  {this.highlightSearchText(item.customjoid, searchTerm)}
                </td>

                {/* Estimation ID */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <Link
                    to={{
                      pathname: "/estimationdetails",
                    }}
                    state={item}
                    className="UI-link"
                    style={{ color: "#152f5f", textDecoration: "none" }}
                  >
                    {this.highlightSearchText(item.customestid, searchTerm)}
                  </Link>
                </td>

                {/* Assign To */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.assigntoname, searchTerm)}
                </td>

                {/* Indenting Status */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <span className={`UI-status-badge ${item.indstatus === 'Completed' ? 'UI-status-completed' :
                    item.indstatus === 'Pending' ? 'UI-status-pending' :
                      item.indstatus === 'Partial' ? 'UI-status-partial' :
                        'UI-status-na'}`}>
                    {this.highlightSearchText(item.indstatus, searchTerm)}
                  </span>
                </td>

                {/* Inprocess Status */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <span className={`UI-status-badge ${item.jostatus === 'Completed' ? 'UI-status-completed' :
                    item.jostatus === 'Pending' ? 'UI-status-pending' :
                      item.jostatus === 'Partial' ? 'UI-status-partial' :
                        'UI-status-na'}`}>
                    {this.highlightSearchText(item.jostatus, searchTerm)}
                  </span>
                </td>

                {/* Status */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <span className={`UI-status-badge ${item.status === 'Completed' ? 'UI-status-completed' :
                    item.status === 'Pending' ? 'UI-status-pending' :
                      item.status === 'Partial' ? 'UI-status-partial' :
                        'UI-status-cancelled'}`}>
                    {this.highlightSearchText(item.status, searchTerm)}
                  </span>
                </td>

                {/* Date */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {moment(item.createdAt).format("DD-MM-YYYY HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderCompletedTable() {
    const { completed, isMobile, searchTerm } = this.state;
    const filteredData = this.getFilteredData(completed);
    const sortedData = this.getSortedData(filteredData);

    if (sortedData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {searchTerm ? 'No completed job orders found matching your search' : 'No completed job orders available'}
        </div>
      );
    }

    return (
      <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
        <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
          <thead className="UI-table-header">
            <tr>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customjoid' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('customjoid')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Job Order ID
                  <this.SortIndicator columnKey="customjoid" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customestid' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('customestid')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Estimation ID
                  <this.SortIndicator columnKey="customestid" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'assigntoname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('assigntoname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Assign To
                  <this.SortIndicator columnKey="assigntoname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'status' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('status')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Status
                  <this.SortIndicator columnKey="status" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('createdAt')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Date
                  <this.SortIndicator columnKey="createdAt" />
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedData.map((item) => (
              <tr
                key={item.id}
                className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                onMouseLeave={() => this.setState({ hoveredRow: null })}
              >
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}>
                  {this.highlightSearchText(item.customjoid, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <Link
                    to={{
                      pathname: "/estimationdetails",
                    }}
                    state={item}
                    className="UI-link"
                    style={{ color: "#152f5f", textDecoration: "none" }}
                  >
                    {this.highlightSearchText(item.customestid, searchTerm)}
                  </Link>
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.assigntoname, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <span className={`UI-status-badge UI-status-completed`}>
                    {this.highlightSearchText(item.status, searchTerm)}
                  </span>
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {moment(item.createdAt).format("DD-MM-YYYY HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderCancelledTable() {
    const { cancelled, isMobile, searchTerm } = this.state;
    const filteredData = this.getFilteredData(cancelled);
    const sortedData = this.getSortedData(filteredData);

    if (sortedData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {searchTerm ? 'No cancelled job orders found matching your search' : 'No cancelled job orders available'}
        </div>
      );
    }

    return (
      <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
        <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
          <thead className="UI-table-header">
            <tr>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customjoid' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('customjoid')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Job Order ID
                  <this.SortIndicator columnKey="customjoid" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customestid' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('customestid')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Estimation ID
                  <this.SortIndicator columnKey="customestid" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'assigntoname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('assigntoname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Assign To
                  <this.SortIndicator columnKey="assigntoname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'status' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('status')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Status
                  <this.SortIndicator columnKey="status" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('createdAt')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Date
                  <this.SortIndicator columnKey="createdAt" />
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedData.map((item) => (
              <tr
                key={item.id}
                className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                onMouseLeave={() => this.setState({ hoveredRow: null })}
              >
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}>
                  {this.highlightSearchText(item.customjoid, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <Link
                    to={{
                      pathname: "/estimationdetails",
                    }}
                    state={item}
                    className="UI-link"
                    style={{ color: "#152f5f", textDecoration: "none" }}
                  >
                    {this.highlightSearchText(item.customestid, searchTerm)}
                  </Link>
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.assigntoname, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <span className={`UI-status-badge UI-status-cancelled`}>
                    {this.highlightSearchText(item.status, searchTerm)}
                  </span>
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {moment(item.createdAt).format("DD-MM-YYYY HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderTable() {
    const { activeTab } = this.state;

    switch (activeTab) {
      case 'active':
        return this.renderActiveTable();
      case 'completed':
        return this.renderCompletedTable();
      case 'cancelled':
        return this.renderCancelledTable();
      default:
        return this.renderActiveTable();
    }
  }

  render() {
    const { isMobile, showSearch, searchTerm, activeTab, loading } = this.state;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
                <nav className={`UI-breadcrumb ${isMobile ? 'UI-breadcrumb-mobile' : ''}`}>
                  <Link
                    to="/production"
                    className={`UI-breadcrumb-item ${this.state.hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                    onMouseEnter={() => this.setState({ hovered: 'home' })}
                    onMouseLeave={() => this.setState({ hovered: null })}
                  >
                    Home
                  </Link>
                  <span>/</span>
                  <span className="UI-breadcrumb-item UI-breadcrumb-active">
                    Job Order
                  </span>
                </nav>

                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>
                      Job Order
                    </h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      Manage active, completed and cancelled job orders
                    </p>
                  </div>

                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                        className="UI-mobile-search-input"
                      />
                    )}

                    <div className={`UI-buttons-row ${isMobile ? 'UI-buttons-row-mobile' : ''}`}>
                      {/* Desktop Search Toggle */}
                      {!isMobile && (
                        <div
                          className={`UI-search-container ${showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                          onClick={() => {
                            if (!showSearch) this.setState({ showSearch: true });
                          }}
                          onMouseEnter={() => this.setState({ hovered: "search" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i
                            className="fa fa-search UI-search-icon"
                          />
                          {!showSearch && "Search"}
                          {showSearch && (
                            <input
                              type="text"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={(e) => this.handleSearch(e.target.value)}
                              className="UI-search-input"
                              autoFocus
                              onClick={(e) => e.stopPropagation()}
                              onBlur={() => {
                                if (searchTerm.trim() === "") {
                                  this.setState({ showSearch: false });
                                }
                              }}
                            />
                          )}
                        </div>
                      )}

                      {/* PDF Export button */}
                      <button
                        className={`UI-btn UI-btn-secondary ${this.state.hovered === "pdf" ? 'UI-btn-secondary-hover' : ''} ${isMobile ? 'UI-btn-mobile' : ''}`}
                        onClick={this.pdf}
                        onMouseEnter={() => this.setState({ hovered: "pdf" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className="fa fa-file-pdf" /> {isMobile ? "PDF" : "Export PDF"}
                      </button>

                      {/* New Job Order button - Only show with permissions */}
                      {(productionid === "2" || productionid === "3") && (
                        <Link
                          as="button"
                          to={{
                            pathname: "/newjoborder"
                          }}
                          state={{
                            id: -1,
                            pagename: "New JobOrder",
                            salestype: false,
                          }}
                          className={`UI-btn UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''} ${isMobile ? 'UI-btn-mobile' : ''}`}
                          onMouseEnter={() => this.setState({ hovered: "new" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-plus" /> {isMobile ? "New" : "New Job Order"}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {loading ? (
                <div className="UI-loading-container">
                  {spin}
                </div>
              ) : (
                <>
                  {this.renderTabs()}
                  <div style={{ marginTop: '16px' }}>
                    {this.renderTable()}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
export default withRouter(JobOrder);